// app/customs/aiagent/index.tsx
'use client';

import React, { useMemo, useState } from 'react';
import './index.css';

const moodIcons = ['😊', '🔍', '⏳', '🌱', '😮', '😅'];

const AiAgent: React.FC = () => {
  const [micEnabled, setMicEnabled] = useState(false);
  const [speakerEnabled, setSpeakerEnabled] = useState(true);
  const [cameraEnabled, setCameraEnabled] = useState(false);
  const moodIcon = useMemo(() => moodIcons[Math.floor(Math.random() * moodIcons.length)], []);

  return (
    <section className="aiagent-widget" aria-label="AIエージェント">
      <div className="aiagent-header">
        <span className="aiagent-badge">AGENT</span>
        <span className="aiagent-mood" aria-hidden="true">{moodIcon}</span>
        <select className="aiagent-select" value="sophia" aria-label="エージェント選択" disabled>
          <option value="sophia">ソフィア</option>
        </select>
      </div>
      <div className="aiagent-activity" aria-label="アクティビティ">
        <div>待機中</div>
      </div>
      <div className="aiagent-tools" aria-label="エージェント操作">
        <button
          type="button"
          className={micEnabled ? 'aiagent-tool active' : 'aiagent-tool'}
          title="マイク"
          aria-pressed={micEnabled}
          onClick={() => setMicEnabled((v) => !v)}
        >
          <i className="fa-solid fa-microphone" />
        </button>
        <button
          type="button"
          className={speakerEnabled ? 'aiagent-tool active' : 'aiagent-tool'}
          title="スピーカー"
          aria-pressed={speakerEnabled}
          onClick={() => setSpeakerEnabled((v) => !v)}
        >
          <i className="fa-solid fa-volume-high" />
        </button>
        <button
          type="button"
          className={cameraEnabled ? 'aiagent-tool active' : 'aiagent-tool'}
          title="カメラ"
          aria-pressed={cameraEnabled}
          onClick={() => setCameraEnabled((v) => !v)}
        >
          <i className="fa-solid fa-camera" />
        </button>
        <button type="button" className="aiagent-tool" title="承認">
          <i className="fa-solid fa-check-to-slot" />
        </button>
      </div>
      <textarea
        className="aiagent-input"
        rows={5}
        placeholder="ソフィアへ依頼..."
      />
    </section>
  );
};

export default AiAgent;
